/**
 * The arrow both diagrams draw between two nodes.
 *
 * A line and a solid head, as one SVG. The CSS-mask version this replaces built
 * the head from a conic-gradient wedge, which renders visibly lopsided at this
 * size — and it had to be re-derived in each stylesheet that wanted one.
 *
 * `currentColor` throughout, so a caller says what a hop means by setting
 * `color` on it rather than by passing a variant.
 */

import './Arrow.scss';

interface ArrowProps {
  /** Total width. The head always takes the last 8px. Ignored when `stretch`. */
  width?: number;
  /**
   * Fill the space between two nodes instead of taking a fixed width. An SVG
   * cannot do this on its own without scaling the head with the shaft, so the
   * stretched form is a flex line plus a fixed head.
   */
  stretch?: boolean;
  className?: string;
}

export function Arrow({ width = 54, stretch, className }: ArrowProps) {
  if (stretch) {
    return (
      <span className={`arrow arrow--stretch ${className ?? ''}`} aria-hidden="true">
        <span className="arrow__line" />
        <svg width="8" height="12" viewBox="0 0 8 12">
          <path d="M0 2 L7 6 L0 10 Z" fill="currentColor" />
        </svg>
      </span>
    );
  }

  const shaft = width - 8;

  return (
    <svg
      className={className}
      width={width}
      height="12"
      viewBox={`0 0 ${width} 12`}
      aria-hidden="true"
    >
      <line x1="0" y1="6" x2={shaft} y2="6" stroke="currentColor" strokeWidth="1.5" />
      <path d={`M${shaft} 2 L${width - 1} 6 L${shaft} 10 Z`} fill="currentColor" />
    </svg>
  );
}
